import React, { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import Select2 from '../../UI/Select2';
import {
  getEscuelasSelectorService,
  getPlantelesByEscuelaService,
} from '../../../services/users/users.service';
import { setEscuela, setPlantel } from '../../../store/reducers/dashboard/dashboardFilters/dashboardFilters.slice';

import CardMejoresTalentos from '../ranking/MejoresTalentos';
import CardMenosTalentos from '../ranking/MenosTalentos';
import CardDistribucionTalentos from '../ranking/CardDistribucionTalentos';
import CardDominanciaSimple from '../ranking/CardDominanciaSimple';
import EstadisticasEvaluacion from '../evaluacion/EstadisticasEvaluacion';
import ResultadosEvaluacionContainer from '../evaluacion/ResultadosEvaluacionContainer';

const Dashboard = () => {
  const dispatch = useDispatch();
  const { escuela, plantel } = useSelector((state) => state.dashboardFilters);

  const fetchEscuelas = useCallback(async (search) => {
    try {
      const data = await getEscuelasSelectorService(search);
      return data.map((item) => ({ id: item.id, label: item.label }));
    } catch (e) {
      console.error('error fetching escuelas', e);
      return [];
    }
  }, []);

  const fetchPlanteles = useCallback(
    async (search) => {
      if (!escuela) return [];
      try {
        const data = await getPlantelesByEscuelaService(escuela, search);
        return data.map((item) => ({ id: item.id, label: item.label }));
      } catch (e) {
        console.error('error fetching planteles', e);
        return [];
      }
    },
    [escuela],
  );

  return (
    <>
      <div className="card mb-24">
        <div className="card-body p-24">
          <h6 className="mb-16 fw-semibold text-lg">Filtros</h6>
          <div className="row g-20 ">
            <div className="col-lg-6 col-md-6 col-12">
              <Select2
                value={escuela || ''}
                onChange={(id) => dispatch(setEscuela(id))}
                fetchOptions={fetchEscuelas}
                placeholder="Seleccionar escuela"
                label="Escuela"
                className="w-100"
              />
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <Select2
                value={plantel || ''}
                onChange={(id) => dispatch(setPlantel(id))}
                fetchOptions={fetchPlanteles}
                placeholder="Seleccionar plantel"
                label="Plantel"
                className="w-100"
                disabled={!escuela}
              />
            </div>
          </div>
        </div>
      </div>

 <section className="row gy-4 mb-24">
      {/* Estadísticas de Evaluación */}
      <EstadisticasEvaluacion />
      {/* Tabla de Resultados de Evaluación */}
      <ResultadosEvaluacionContainer />
    </section>

      <section className="row gy-4 mb-24">
        {/* CardMejoresTalentos */}
        <CardMejoresTalentos />

        {/* CardMenosTalentos */}
        <CardMenosTalentos />

        <CardDistribucionTalentos />
        { <CardDominanciaSimple /> }
      </section>

      
    </>
  );
}

export default Dashboard
